import React, { useState } from 'react';
import axios from 'axios';
import { Outlet, useNavigate } from 'react-router-dom';
import { FaDownload, FaUpload, FaTrash, FaSignOutAlt } from 'react-icons/fa';
import ContactList from './pages/Supports/ContactList.js';
import Skills from './pages/Menu/Skills';
import Services from './pages/Management/Service/Services.js';
import BlogCategory from './pages/Management/Blogs/BlogCategory.js'
import Workinghistory from './pages/Menu/Workinghistory';
import EducationHistory from './pages/Menu/Educationhistory';
// import ProjectsOfMe from './ProjectsOfMe';
import AllProjects from './pages/Management/Projects/AllProjects.js';
import WorkWithMeList from './pages/Supports/WorkWithMeList.js';
import SatisfiedClients from './pages/Myclients/SatisfiedClients.js';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import APIEndPoints from '../middleware/APIEndPoints.js';


const AdminHome = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
  const [open, setOpen] = useState(false);


  const getSignOutURl = APIEndPoints.sign_out.url;
  const getUploadCVURl = APIEndPoints.uploadCV.url;
  const getDeleteCVURl = APIEndPoints.deleteCV.url;



  const navigate = useNavigate();

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append('cv', selectedFile);

    try {
      await axios.post(getUploadCVURl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert("File uploaded successfully.");
    } catch (err) {
      console.error("Upload error:", err);
      alert("File upload failed.");
    }
  };

  const handleDelete = async () => {
    try {
      await axios.delete(getDeleteCVURl);
      alert("File deleted successfully.");
    } catch (err) {
      console.error("Delete error:", err);
      alert("File deletion failed.");
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(getSignOutURl, {}, { withCredentials: true });

      localStorage.removeItem('user'); 

      alert("Logged out successfully.");
      navigate('/'); 
    } catch (err) {
      console.error("Logout error:", err);
      alert("Logout failed.");
    }
  };


  return (
    <div>
      <div className='ml-0 mt-16 md:ml-64 md:mt-16  '>

        {/* the pages here where all the contains will be here */}
        <Outlet/>


      </div>


    </div>
  );
};

export default AdminHome;

//all function here

// <div className=' flex justify-center items-center flex-col space-y-4'>

// {/* UPLOAD AND DOWNLOAD AND DELETE PDF */}
// <div className='flex justify-center items-center flex-col space-y-4'>

//   <input type="file" onChange={handleFileChange} />
//   <button onClick={handleUpload}>
//     <FaUpload /> Upload CV
//   </button>
//   <button onClick={handleDelete}>
//     <FaTrash /> Delete CV
//   </button>
//   <a href="http://localhost:8800/api/files/download-cv" className='bg-white text-black'>
//     <FaDownload /> Download CV
//   </a>
// </div>


// {/* CONTACT USS LIST PAGINATION AND DELETE */}
// <div>
//   <ContactList />

// </div>

// {/* SKILLS  */}
// <div>
//   <Skills />
// </div>

// {/* SERVICES */}
// <div>
//   <Services />
// </div>

// {/* BLOGS */}

// <div>
//   <BlogCategory />
// </div>


// {/* WOrking history */}
// <div>
//   <Workinghistory />

// </div>
// {/* WOrking history */}
// <div>
//   <EducationHistory />

// </div>

// <div>
//   <AllProjects />

// </div>


// <div>
//   <WorkWithMeList />
// </div>


// <div>
//   <SatisfiedClients />
// </div>

// {/* LOGOUT BUTTON */}
// <div>
//   <button
//     onClick={() => setShowLogoutConfirmation(true)}
//     className='bg-red-500 text-white p-2 rounded flex items-center'
//   >
//     <FaSignOutAlt className='mr-2' /> Logout
//   </button>
// </div>

// {/* LOGOUT CONFIRMATION MODAL */}
// {showLogoutConfirmation && (
//   <div className='fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center'>
//     <div className='bg-white p-6 rounded shadow-lg text-center'>
//       <p className='mb-4'>Are you sure you want to log out?</p>
//       <div className='flex justify-center space-x-4'>
//         <button
//           onClick={handleLogout}
//           className='bg-red-500 text-white px-4 py-2 rounded'
//         >
//           Yes
//         </button>
//         <button
//           onClick={() => setShowLogoutConfirmation(false)}
//           className='bg-gray-500 text-white px-4 py-2 rounded'
//         >
//           Cancel
//         </button>
//       </div>
//     </div>
//   </div>
// )}

// </div>

